import type { AdminFlowTool } from "../models/admin-flows.models";

// Native definitions express their primary family through audience rather than a display category.
// Keep direct email actions outside the AI step picker even when an entitled developer can discover them.
export const getAdminFlowToolGroup = (tool: AdminFlowTool): string => {
  if (tool.category === "OGA" || tool.name.startsWith("oga_")) {
    return "OGA";
  }

  if (tool.audience === "developer") {
    return "Developer Diagnostics";
  }

  if (tool.audience === "admin") {
    return "Admin";
  }

  return "Business";
};

// Seed only broad read settings; real vessel identifiers must come from the administrator.
export const getAdminFlowSourceArguments = (source: string): Record<string, unknown> => {
  if (source === "vessels") {
    return { operation: "read", view: "fleet_filters", limit: 10 };
  }

  if (source === "support" || source === "offline_tech_form") {
    return { pageSize: 5 };
  }

  return {};
};
